import React, { useState } from 'react';
import { Input, Table, Typography } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { getStockHistory } from '../../../actions/report';

const { Title } = Typography;

const StockHistoryPage = () => {
  const [title, setTitle] = useState('');
  const [floatingTransfers, setFloatingTransfers] = useState([]);
  const [productStocks, setProductStocks] = useState([]);
  const [productEntries, setProductEntries] = useState([]);
  const [soldProducts, setSoldProducts] = useState([]);
  const [damageProducts, setDamageProducts] = useState([]);
  const [summary, setSummary] = useState(null);

  console.log('productEntries', productEntries)
  console.log('floatingTransfers', floatingTransfers)
  console.log('soldProducts', soldProducts)
  console.log('productStocks', productStocks)
  console.log('damageProducts', damageProducts)

  const dispatch = useDispatch();

  const handleSearch = async () => {
    const result = await dispatch(getStockHistory(title));
    if (result) {
      setFloatingTransfers(result.floating_transfers || []);
      setProductStocks(result.product_stocks || []);
      setProductEntries(result.product_entries || []);
      setSoldProducts(result.sold_products || []);
      setDamageProducts(result.damage_stocks || []);
      setSummary(result.summary || null);
    }
  };

  const columnsFloating = [
    { title: 'Transfer Number', dataIndex: 'transfer_number', key: 'transfer_number' },
    { title: 'Source', dataIndex: 'source', key: 'source' },
    { title: 'Distance', dataIndex: 'destance', key: 'destance' },
    { title: 'Attributes', dataIndex: 'product_attributes', key: 'product_attributes' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
  ];

  const columnsStock = [
    { title: 'Attribute Details', dataIndex: 'Attribute_details', key: 'Attribute_details' },
    { title: 'Warehouse', dataIndex: 'Warehouse_name', key: 'Warehouse_name' },
    { title: 'Category', dataIndex: 'category', key: 'category' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
  ];

  const columnsEntry = [
    { title: 'Warehouse', dataIndex: ['ProductLocation', 'Warehouse_name'], key: 'Warehouse_name' },
    { title: 'Attribute Details', dataIndex: ['ProductLocation', 'Attribute_details'], key: 'attribute' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Created At', dataIndex: 'created', key: 'created' },
  ];

  const columnsSold = [
    { title: 'Invoice', dataIndex: 'invoice', key: 'invoice' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Issued Date', dataIndex: 'created_at', key: 'created_at' },
  ];

  const columnsDamage = [
    { title: 'Attributes', dataIndex: 'attributes_details', key: 'attributes_details' },
    { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Location', dataIndex: 'warehouse_name', key: 'warehouse_name' },
    { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' },
    { title: 'Issued Date', dataIndex: 'created_at', key: 'created_at' },
  ];



  const columnsSummary = [
    { title: 'Total Product Entries', dataIndex: 'total_entries', key: 'total_entries' },
    { title: 'Total Product Stocks', dataIndex: 'total_stocks', key: 'total_stocks' },
    { title: 'Floating Transfers', dataIndex: 'total_floating', key: 'total_floating' },
    { title: 'Sold Products', dataIndex: 'total_sold', key: 'total_sold' },
    { title: 'Damage Stocks', dataIndex: 'total_damage', key: 'total_damage' },
    {
      title: 'Balance Status',
      dataIndex: 'is_balanced',
      key: 'is_balanced',
      render: (is_balanced) =>
        is_balanced ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Stock History Report</Title>
      <Input.Search
        placeholder="Search Product Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onSearch={handleSearch}
        enterButton
        style={{ marginBottom: 24, width: 400 }}
      />

      {summary && (
        <>
          <Title level={4}>Summary</Title>
          <Table
            dataSource={[
              {
                key: 'summary',
                total_entries: summary.total_entries,
                total_stocks: summary.total_stocks,
                total_floating: summary.total_floating,
                total_sold: summary.total_sold,
                total_damage: summary.total_damage,
                is_balanced: summary.is_balanced,
              },
            ]}
            columns={columnsSummary}
            pagination={false}
            rowKey="key"
            style={{ marginBottom: 24 }}
          />
        </>
      )}

      <Title level={4}>Product Entries</Title>
      <Table dataSource={productEntries} columns={columnsEntry} rowKey="id" />

      <Title level={4}>Floating Transfers</Title>
      <Table dataSource={floatingTransfers} columns={columnsFloating} rowKey="id" />

      <Title level={4}>Sold Products</Title>
      <Table dataSource={soldProducts} columns={columnsSold} rowKey="id" />

      <Title level={4}>Product Stocks</Title>
      <Table dataSource={productStocks} columns={columnsStock} rowKey="id" />

      <Title level={4}>Damage Stocks</Title>
      <Table dataSource={damageProducts} columns={columnsDamage} rowKey="id" />
    </div>
  );
};

export default StockHistoryPage;
